module.exports = __webpack_public_path__ + "static/segmentation-search-2-83aa407c018b0839f741ac66deee0b34.png";